import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import BuildInputs from './../../shared/widgets/BuildInputs';
import SelectWidget from './SelectWidget';
import ChartTypeHelper from './helpers/ChartTypeHelper';
import DataLabelsHelper from './helpers/DataLabelsHelper';
import { GenericInputProps, InputChangeParams } from 'shared/types/commonPropTypes';
import { customSelectColors } from 'shared/inputs/CustomSelect';
import { get } from 'lodash';
import { getFilteredValue, getIndexFromPath } from './helpers/WidgetHelper';

type SelectProps = {
  selectOptions: [];
  selectValue: unknown;
  onChangeSelect: () => void;
  filteredOptions: {
    filteredOptions: unknown[];
  };
  extractValue?: (property: unknown) => any;
  onChangeValue?: (type: unknown, option: unknown, val: unknown) => void;
};

const getPropsMap = {
  chartType: ChartTypeHelper,
  dataLabels: DataLabelsHelper
};

const DependencySelectWidget = (props: GenericInputProps) => {
  const [detailIndex, setDetailIndex] = useState(props.option?.controlledBy?.default ?? 0);
  const dispatch = useDispatch();
  const { option } = props;
  const controlledBy = option?.controlledBy;
  const propsMapIndex = controlledBy?.type as keyof typeof getPropsMap;
  const getProperties = getPropsMap[propsMapIndex]({ dispatch, props });

  const onOptionChange = (value: InputChangeParams) => setDetailIndex(value.val);

  const { selectOptions, selectValue, onChangeSelect, filteredOptions, extractValue, onChangeValue }: SelectProps =
    getProperties({
      detailIndex,
      onOptionChange
    });

  let className = '';
  if (propsMapIndex === 'chartType') {
    const series = get(props.aggregatedOptions, 'series');
    const moreThanOneSeries = (series ?? []).length > 1;
    if (moreThanOneSeries) className = 'bg-ev-grey';
    else className = 'bg-white';

    filteredOptions.filteredOptions = (filteredOptions.filteredOptions ?? []).map((field: any) => ({
      ...field,
      className,
      backgroundColor: moreThanOneSeries ? customSelectColors.grey : customSelectColors.white
    }));
  }

  let showDropdown = true;

  if (option?.filteredBy && option.subType) {
    const index = getIndexFromPath(props.parentPath);
    const type = getFilteredValue(option, props.chart, index);
    showDropdown = option.subType.includes(type);
  }

  return (
    <>
      {showDropdown && (
        <div className="highed-customize-master-dropdown">
          <SelectWidget
            selectOptions={selectOptions}
            value={selectValue}
            onChange={onChangeSelect}
            label={props.label}
            className={className}
            backgroundColor={className}
            option={props.option}
          />
          {option?.showSeparatorLine && <hr className="border-ev-grey-3 mt-2 mb-4" />}
        </div>
      )}

      {((filteredOptions as any).options || filteredOptions.filteredOptions) && (
        <div className="highed-customizer-table flex flex-col w-full mt-0">
          <BuildInputs
            section={filteredOptions}
            parentKey={''}
            parentPath={`${option?.id}[${detailIndex}]`}
            overrideOnChange={onChangeValue}
            overrideExtractValue={extractValue}
            index={(detailIndex ?? 0) as number}
          />
        </div>
      )}
    </>
  );
};

export default DependencySelectWidget;
